module.exports = __webpack_public_path__ + "static/media/26UNRWA19.feaf8bb7.jpg";